export default __webpack_public_path__ + "static/media/essentials.133926b5.svg";